export interface ServiceArea {
  name: string;
  state: string;
  primary?: boolean;
}

export const serviceAreas: ServiceArea[] = [
  { name: 'Houston', state: 'TX', primary: true },
  { name: 'Pearland', state: 'TX' },
  { name: 'Friendswood', state: 'TX' },
  { name: 'League City', state: 'TX' },
  { name: 'Galveston', state: 'TX' },
  { name: 'Pasadena', state: 'TX' },
  { name: 'La Porte', state: 'TX' },
  { name: 'Deer Park', state: 'TX' },
  { name: 'Baytown', state: 'TX' },
  { name: 'Sugar Land', state: 'TX' },
  { name: 'Missouri City', state: 'TX' },
  { name: 'Stafford', state: 'TX' },
  { name: 'Richmond', state: 'TX' },
  { name: 'Katy', state: 'TX' },
  { name: 'Cypress', state: 'TX' },
  { name: 'Spring', state: 'TX' },
  { name: 'The Woodlands', state: 'TX' },
  { name: 'Clear Lake', state: 'TX' },
  { name: 'Webster', state: 'TX' },
  { name: 'Seabrook', state: 'TX' },
  { name: 'Kemah', state: 'TX' },
];
